/**
 * --------------------------------
 * REGISTER GSAP PLUGINS
 * --------------------------------
 */

gsap.registerPlugin(ScrollTrigger)

/*
 * PAGE: Homepage
 * Section: Video with "CLUB CUTRER" title
 * Animation: Reduce video's width and increase border radius when scrolling down
 */

const l_homepageCutrerVideo = () => {
	const videoSectionEl = document.getElementById('l-club-cutrer-video')
	if (!videoSectionEl) return

	const sectionEl = videoSectionEl.parentElement
	const videoEl = videoSectionEl.querySelector('.l-bVideo')
	const mainContentEl = document.querySelector('[data-main-content]')
	const overlayContentEl = document.querySelector('[data-overlay-content]')
	const maskEl = document.querySelector('[data-mask]')

	if (!sectionEl || !videoEl || !mainContentEl || !overlayContentEl || !maskEl) return

	l_attachResetScrollPositionListener()

	const mm = gsap.matchMedia()

	mm.add('(min-width: 1024px)', () => {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: videoSectionEl,
				start: 'top top',
				end: '+=120%',
				scrub: 0.6,
				pin: true,
				anticipatePin: 1,
				invalidateOnRefresh: true,
			},
		})

		tl.fromTo(
			sectionEl,
			{ backgroundColor: '#F5F4F2' },
			{
				backgroundColor: 'var(--l-section-background)',
				ease: 'none',
				duration: 0.25,
			},
			0.1
		)

		tl.fromTo(
			videoEl,
			{
				scale: 1,
				transformOrigin: 'center center',
			},
			{
				scale: 0.35,
				ease: 'none',
				duration: 1,
			},
			0
		)

		tl.fromTo(
			overlayContentEl,
			{
				opacity: 1,
				pointerEvents: 'auto',
			},
			{
				opacity: 0,
				pointerEvents: 'none',
				ease: 'none',
				duration: 0.25,
			},
			0.2
		)

		tl.fromTo(
			mainContentEl,
			{
				opacity: 0,
				pointerEvents: 'none',
			},
			{
				opacity: 1,
				pointerEvents: 'auto',
				ease: 'none',
				duration: 0.25,
			},
			0.8
		)

		tl.fromTo(
			maskEl,
			{
				opacity: 0,
				pointerEvents: 'none',
			},
			{
				opacity: 1,
				pointerEvents: 'auto',
				ease: 'none',
				duration: 0.25,
			},
			0.8
		)
	})

	return mm
}

/*
 * Section: A - Rooted in Sonoma
 * Animation: Scale up the primary image and move the secondary image to the right when scrolling down
 */

const l_sRISonoma = () => {
	const mm = gsap.matchMedia()

	mm.add('(min-width: 1024px)', () => {
		const sections = document.querySelectorAll('.l-sRISonoma')
		if (!sections.length) return

		l_attachResetScrollPositionListener()

		sections.forEach((section) => {
			const imageEl = section.querySelector('.js-primary-image-desktop')
			if (!imageEl) return

			const parallaxImages = section.querySelectorAll('.js-ris-parallax-image')

			gsap.fromTo(
				imageEl,
				{ scale: 0.5 },
				{
					scale: 1,
					ease: 'none',
					scrollTrigger: {
						trigger: section,
						start: 'top center',
						end: '+=120%',
						scrub: 0.6,
						invalidateOnRefresh: true,
					},
				}
			)

			parallaxImages.forEach((el) => {
				gsap.fromTo(
					el,
					{ y: '-30%', x: -30 },
					{
						y: '0%',
						x: 0,
						scrollTrigger: {
							trigger: section,
							start: 'top top',
							end: '+=150%',
							scrub: true,
							invalidateOnRefresh: true,
						},
					}
				)
			})
		})
	})

	return mm
}

/*
 * PAGE: About Us
 * Section: A - About Us
 */

const l_aboutUsPage = () => {
	const mm = gsap.matchMedia()

	mm.add('(min-width: 1024px)', () => {
		const parallaxImages = document.querySelectorAll('.js-parallax-image')

		if (parallaxImages.length === 0) return

		l_attachResetScrollPositionListener()

		parallaxImages.forEach((el) => {
			const sectionParentEl = el.closest('.l-section')
			if (!sectionParentEl) return

			gsap.fromTo(
				el,
				{ y: '-10%' },
				{
					y: '0%',
					scrollTrigger: {
						trigger: sectionParentEl,
						start: 'top 50%',
						end: '+=50%',
						scrub: true,
						invalidateOnRefresh: true,
					},
				}
			)
		})
	})

	return mm
}

document.addEventListener('DOMContentLoaded', () => {
	const initAnimations = () => {
		l_homepageCutrerVideo()
		l_sRISonoma()
		l_aboutUsPage()
	}

	if (window.location.hash) {
		l_debounce(initAnimations, 200)()
	} else {
		initAnimations()
	}
})

